import React from "react";
import store from "../../../../Store";
import { connect } from "react-redux";
import { withRouter } from "react-router";
import getServerModules from "../../../../ajax/actions/server-module/server_modules_get";
import { setDefaultServerMigration } from "./ServerMigration-Action";
import createServerMigration from "../../../../ajax/actions/server-migrate/server_migrate_post";

class ServerMigrationWorker extends React.Component {
  constructor(props) {
    super(props);
    let paginate = false;
    store.dispatch(setDefaultServerMigration());
    store.dispatch(getServerModules(paginate));
  }

  componentDidUpdate(prev) {
    let { dispatchAPI } = this.props;
    if (dispatchAPI) {
      if (!prev.dispatchAPI) {
        store.dispatch(
          createServerMigration(
            this.props.match.params.id,
            this.props.organizationDashboard.data.organization_id
          )
        );
      }
    }
  }

  render() {
    return null;
  }
}

function mapStateToProps(state) {
  let {
    serverMigrationForm,
    createServerMigration,
    organizationDashboard,
    getSite,
  } = state;
  let { dispatchAPI, mode, payload } = serverMigrationForm.data;
  return {
    serverMigrationForm,
    dispatchAPI,
    mode,
    payload,
    createServerMigration,
    organizationDashboard,
    getSite,
  };
}

export default withRouter(connect(mapStateToProps)(ServerMigrationWorker));
